import * as React from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export default function InfoBar({message, closeInfoBar}) {
  const [open, setOpen] = React.useState( (message !== '' ) && (message != undefined) );
  const [message1, setMessage1] = React.useState( message )
  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    closeInfoBar();
    setOpen(false);
  };

  const action = (
    <React.Fragment>
 
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={16000}
        onClose={handleClose}
        message={message1}
        action={action}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./routes/app/components/Agent/InfoBar/index.js